import { Component, Input, OnInit } from '@angular/core';
import { AvatarSize, ButtonType, ButtonVariant, IconName } from '@yupma/ui-kit';
import { UserDocument } from 'server-model';
import { RouteLinkGenerator, RouteName } from 'src/app/routing-path';
import { IAMService, UserDataService } from 'src/app/services/services.module';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
  @Input() showBackNavigation: boolean = false;

  title: string = 'Home';
  iconNames = IconName;
  buttonVariants = ButtonVariant;
  buttonTypes = ButtonType;
  avatarSizes = AvatarSize;
  routeNames = RouteName;

  settingsRoute = RouteLinkGenerator.settings('')

  constructor(
    private iamService: IAMService,
    private userDataService: UserDataService,
  ) { }

  ngOnInit() {
    this.init()
  }

  private async init() {
    try {
      // const uid = this.iamService.getUserId();
      const organisationId = this.iamService.getOrganisationId();
      this.settingsRoute = RouteLinkGenerator.settings(organisationId);
      // this.userDocument = await this.userDataService.getUser(uid);
    } catch (error) {
      console.log(error)
    }
  }
}
